export default "__VITE_ASSET__BtJ3qrsM__"